import APIServices from "./APIServices";
import {POST} from "../constants/HTTPConstants";

export const _checkTradeMark = (text) => {
    return APIServices.makeRequest({
        url: '/check',
        method: POST,
        data: {
            text
        }
    });
};


// WEBPACK FOOTER //
// ./src/services/TrademarkServices.js